
import { bootstrapMontageApp } from '@core/bootstrap';
import { TPortalType } from '@core/enums/portal-type.enum';

import { MJC_APP } from './app/app';
import { AppComponent } from './app/app.component';

bootstrapMontageApp(AppComponent, MJC_APP, TPortalType.MJC);
